// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2i76A","radioRow":"SimpleQuestionBuilderModal_radioRow__21VLT"};